import React, { FC, useState } from "react";
import { Placeholder } from "kanopi-components/Placeholder";
import { quoteFlowFields } from "kw/api/fragments";
import { RouteComponentProps } from "@reach/router";
import { useMatchParams } from "kanopi-components/hooks/useMatchParams";
import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";

type TPolicyCancellationFlowPage = {
  policyId: string;
};

export const PolicyCancellationFlowPage: FC<
  TPolicyCancellationFlowPage & RouteComponentProps
> = ({ policyId, uri: prefix }) => {
  const { questionSetKey } = useMatchParams(`${prefix}/:questionSetKey`);
  const startPolicyCancellationQuery = {
    startCancellation: [
      {
        input: {
          policyId: policyId,
        },
      },
      {
        ...quoteFlowFields,
      },
    ],
  };
  const [currentMaxSet, setCurrentMaxSet] = useState({
    currentSet: 0,
    maxSets: 1,
  });

  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _totalSets = { ...currentMaxSet };
    _totalSets.currentSet = currentSet;
    _totalSets.maxSets = maxSets;
    setCurrentMaxSet(_totalSets);
  };

  return (
    <Placeholder>
      <QuestionFlowComponent
        isFlowLayout={false}
        actionFlowType={QuestionFlowTypeEnum.Cancel}
        prefix={prefix}
        finishedRoute={`/policies/${policyId}/cancel`}
        defaultBackLocation={`/policies/${policyId}/cancel/`}
        actionQuery={startPolicyCancellationQuery}
        questionFlowResponseKey="startCancellation"
        questionSetKey={questionSetKey}
        onCurrentAndMaxSetChange={onCurrentMaxSetChange}
      />
    </Placeholder>
  );
};
